import React, { useState } from 'react';
import Header from './Header';
import Hero from './Hero';
import Services from './Services';
import Countries from './Countries';
import Pricing from './Pricing';
import Contact from './Contact';
import Footer from './Footer';
import SEO from './SEO';
import NoctrifyPromo from './NoctrifyPromo';
import { getOrganizationSchema, getWebsiteSchema, getServiceSchema } from '../utils/structuredData';

const HomePage = () => {
  const [showNoctrifyPromo, setShowNoctrifyPromo] = useState(false);

  // Combine multiple schemas for the homepage
  const combinedStructuredData = [
    getOrganizationSchema(),
    getWebsiteSchema(),
    getServiceSchema()
  ];

  const handleMeetingBooked = () => {
    // Show Noctrify popup after user books a meeting
    console.log('handleMeetingBooked called - setting showNoctrifyPromo to true');
    setShowNoctrifyPromo(true);
  };

  return (
    <div>
      <SEO
        title="Out of Box - International Company Registration Services | Fast & Reliable"
        description="Professional company registration services worldwide. Expert assistance for business formation, offshore companies, nominee services, and corporate banking in 50+ countries. Get started today!"
        keywords="company registration, business formation, offshore company, international incorporation, business setup, corporate services, nominee director, banking assistance, compliance services"
        structuredData={combinedStructuredData}
        type="website"
      />
      <Header />
      <Hero />
      <Services />
      <Countries />
      <Pricing />
      <Contact onMeetingBooked={handleMeetingBooked} />
      <Footer />
      <NoctrifyPromo triggerShow={showNoctrifyPromo} />
    </div>
  );
};

export default HomePage; 